export const {
    apiHost,
    authHost,
    authClientId,
    logRocketId,
    gitCommitSha,
} = document.getElementsByTagName('body')[0].dataset;
